<template>
	<LoginAccounts
		:accounts="user.accounts"
		:contact="user.phone || user.email"
		@account="onSelect"
	/>
</template>

<script>
import LoginAccounts from '@/components/Login/LoginAccounts'
import { getUserData, getInvite, clearInviteData } from './index'

export default {
	name: 'InviteAccounts',
	components: { LoginAccounts },
	data() {
		return {
			user: getUserData(),
			persist: !!this.$route.query.persist,
		}
	},
	methods: {
		onSelect({ logintoken }) {
			const invite = getInvite()
			redirectToAccount(invite, logintoken, {
				persist: this.persist,
				invite: invite.code,
			})
			clearInviteData()
		},
	},
}
</script>
